<!--
	TODO : We need to establish the view mode.
 -->
<ng-select
	[class.viewOnly]="viewOnly"
	[multiple]="multiple"
	[closeOnSelect]="closeOnSelect"
	[selectableGroup]="selectableGroup"
	[selectableGroupAsModel]="selectableGroupAsModel"
	[groupBy]="groupBy"
	[bindLabel]="bindLabel"
	[bindValue]="bindValue"
	[items]="options$ | async"
	[required]="required"
	[ngModel]="value"
	(ngModelChange)="updateValue($event)"
	(change)="onChange($event)"
	(add)="onAdd($event)"
	(remove)="onRemove($event)"
	(search)="onSearch($event)"
	[disabled]="disabled"
	[readonly]="viewOnly"
	[searchFn]="searchFn"
	[hideSelected]="hideSelected"
	[notFoundText]="'SELECT.notFoundText' | translate"
	[placeholder]="'SELECT.placeholder' | translate"
	[clearAllText]="'SELECT.clearAllText' | translate"
	[addTagText]="'SELECT.addTagText' | translate"
	[typeToSearchText]="'SELECT.typeToSearchText' | translate"
>
	<ng-template ng-label-tmp let-item="item">
		<p
			*ngIf="
				selectedTemplate | renderTemplate : item : formioComponent as template;
				else defaultLabelTpl
			"
			[innerHtml]="template"
		></p>

		<ng-template #defaultLabelTpl>
			{{ item | getValue : bindLabel : 'name' }}
		</ng-template>
	</ng-template>

	<ng-template
		ng-optgroup-tmp
		let-item="item"
		let-item$="item$"
		let-index="index"
	>
		<p
			*ngIf="
				groupTemplate | renderTemplate : item : formioComponent as template;
				else defaultGroupTpl
			"
			[innerHtml]="template"
		></p>

		<ng-template #defaultGroupTpl>
			{{ item | getValue : bindGroup : 'name' }}
		</ng-template>
	</ng-template>
	<ng-template
		ng-option-tmp
		let-item="item"
		let-item$="item$"
		let-index="index"
	>
		<p
			*ngIf="
				itemTemplate | renderTemplate : item : formioComponent as template;
				else defaultItemTpl
			"
			[innerHtml]="template"
		></p>

		<ng-template #defaultItemTpl>
			{{ item | getValue : bindLabel : 'name' }}
		</ng-template>
	</ng-template>
</ng-select>
